import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookie-consent');
    if (!hasConsented) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  const handleManagePreferences = () => {
    // Enhanced cookie preferences with toggles
    const preferences = {
      analytics: confirm('Enable analytics cookies? These help us improve your experience.'),
      functional: true // Always required
    };
    
    localStorage.setItem('cookie-preferences', JSON.stringify(preferences));
    localStorage.setItem('cookie-consent', 'managed');
    setIsVisible(false);
    
    alert(`Preferences saved:\n- Analytics: ${preferences.analytics ? 'Enabled' : 'Disabled'}\n- Functional: Always enabled`);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg p-4 md:p-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <Cookie className="w-6 h-6 text-flexaura-teal" />
          </div>
          
          <div className="flex-1">
            <h3 className="font-heading font-semibold mb-2">We use cookies</h3>
            <p className="text-sm text-muted-foreground mb-4">
              We use cookies to enhance your browsing experience, analyze site traffic, and provide personalized content. 
              By clicking "Accept", you consent to our use of cookies.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <Button 
                onClick={handleAccept}
                variant="gradient" 
                size="sm"
              >
                Accept All Cookies
              </Button>
              <Button 
                onClick={handleManagePreferences}
                variant="outline" 
                size="sm"
              >
                Manage Preferences
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;